var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99992 5.00004C10.9166 5.00004 11.6666 5.75004 11.6666 6.66671C11.6666 7.58337 10.9166 8.33337 9.99992 8.33337C9.08325 8.33337 8.33325 7.58337 8.33325 6.66671C8.33325 5.75004 9.08325 5.00004 9.99992 5.00004ZM9.99992 13.3334C12.2499 13.3334 14.8333 14.4084 14.9999 15H4.99992C5.19159 14.4 7.75825 13.3334 9.99992 13.3334ZM9.99992 3.33337C8.15825 3.33337 6.66659 4.82504 6.66659 6.66671C6.66659 8.50837 8.15825 10 9.99992 10C11.8416 10 13.3333 8.50837 13.3333 6.66671C13.3333 4.82504 11.8416 3.33337 9.99992 3.33337ZM9.99992 11.6667C7.77492 11.6667 3.33325 12.7834 3.33325 15V16.6667H16.6666V15C16.6666 12.7834 12.2249 11.6667 9.99992 11.6667Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.4b3ca596.svg";
export { ForwardRef as ReactComponent };